import React from "react";
import { Route, Navigate, Routes } from 'react-router-dom';
import Layout from "./Layout/Layout";
import NetworkDetector from './Hoc/NetworkDetector';
import Error from "../pages/error/Error";
import Login from "../pages/login/Login";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/app/dashboard" />} />
        <Route path="/app/*" element={<PrivateRoute component={Layout} />} />
        <Route path="/login" element={<PublicRoute component={Login} />} />

        <Route path="*" element={<Error />} />
      </Routes>
      <ToastContainer theme="colored" style={{
        borderRadius: '50px'
      }} stacked={false} />
    </>
  );
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = window.sessionStorage.getItem('adminuser');
  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/login" />;
};

const PublicRoute = ({ component: Component, ...rest }) => {
  return <Component {...rest} />;
};

export default NetworkDetector(App);
